class Elementor_TimelineCarousel {
    static instance;

    static getInstance() {
        if (!Elementor_TimelineCarousel.instance) {
            Elementor_TimelineCarousel.instance = new Elementor_TimelineCarousel();
        }
        return Elementor_TimelineCarousel.instance;
    }

    constructor() {
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init() {
        elementorFrontend.hooks.addAction('frontend/element_ready/opal-timelinecarousel.default', ($scope, $) => {

            let $carousel = $scope.find('.owl-carousel');
            if($carousel.length > 0){
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }

        });
    }
}

Elementor_TimelineCarousel.getInstance();